import React, { useEffect, useRef, useState } from "react";
import InputField from "common/customInputField";
import SelectInput from "common/selectInput";
import edit from "svg/edit_blue.svg";
import Modal from "common/modal";
import Button from "react-bootstrap/Button";
import { useNavigate, useParams } from "react-router-dom";
import { getPrcList } from "store/priceQuote/actionCreator";
import { clearPrcList } from "store/slices/priceQuote";
import { taxFormat } from "../utils";
import { showSpinner, hideSpinner } from "store/slices/spinner";
import { prcService, getJobDetailsService } from "services/priceQuote.service";
import { useSelector, useDispatch } from "react-redux";
import { formatDate } from "utils/common";
import { api } from "store/slices/api";
import { toast } from "react-toastify";
import "./style.scss";

const QuoteDetails = ({ territoryAccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const detailsRef = useRef();
  const customerTypeNode = useRef();
  const jobTypeNode = useRef();

  const { quoteId } = useParams();
  const { prcList } = useSelector((state) => state.priceQuote); //prcList
  const { sub } = useSelector((state) => state.loggedInUser);
  const { data: quoteFields = {}, isFetching: fetchingQuote } = api.useGetPriceQuoteQuery(quoteId);
  const [deprecatedEditQuote] = api.useDeprecatedEditQuoteMutation();
  const [showEditQuoteModal, setShowEditQuoteModal] = useState(false);
  const [dateValid, setDateValid] = useState("");
  const [state, setState] = useState();
  const [dateType, setDateType] = useState("");
  const [prcOptions, setPrcOptions] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [quoteNameMaxLengthMsg, setQuoteNameMaxLengthMsg] = useState("");

  useEffect(() => {
    setJobList([]);
    if (quoteFields?.accountNumber) {
      dispatch(showSpinner());
      getJobDetailsService(quoteFields.accountNumber)
        .then((res) => {
          if (res.length) {
            setJobList(res);
          } else {
            setJobList([]);
          }
          dispatch(hideSpinner());
        })
        .catch((err) => {
          console.log("err", err);
          setJobList([]);
          dispatch(hideSpinner());
        });
    }
  }, [quoteFields?.accountNumber]);

  useEffect(() => {
    if (fetchingQuote === false) {
      setState({ ...quoteFields });
      setDateType(quoteFields.expirationDate === "Upon 30 days notice" ? "default" : "manual");
    }
  }, [fetchingQuote]);

  useEffect(() => {
    if (showEditQuoteModal) setState({ ...quoteFields });
  }, [showEditQuoteModal]);

  const handlePRC = (e, value) => {
    setState({ ...state, prcNumber: value.prcNbr, prcDesc: value.descr });
  };

  const handleJob = (e, value) => {
    setState({ ...state, jobNumber: value.jobNbr, jobName: value.jobName });
    if (value.jobNbr !== "None Available") {
      dispatch(showSpinner());
      prcService({
        acctNbr: quoteFields.accountNumber,
        jobNbr: value.jobNbr,
      })
        .then((res) => {
          if (res?.prcList?.length && res?.prcList !== null) {
            function prcData(data) {
              const { prcNbr, descr } = data;
              return { prcNbr, descr };
            }
            const prcOptionList = res?.prcList?.map(prcData);
            setPrcOptions(prcOptionList);
            setState({
              ...state,
              prcNumber: prcOptionList[0]?.prcNbr,
              prcDesc: prcOptionList[0]?.descr,
              jobNumber: value.jobNbr,
              jobName: value.jobName,
            });
          } else {
            setPrcOptions([]);
            setState({ ...state, prcNumber: "", prcDesc: "", jobNumber: value.jobNbr, jobName: value.jobName });
          }
          dispatch(hideSpinner());
        })
        .catch((err) => {
          console.error(err);
          dispatch(closeSpinner());
        });
    }
  };

  const handleEditQuoteInfo = () => {
    setShowEditQuoteModal(true);
    let payload = { acctNbr: quoteFields.accountNumber, jobNbr: quoteFields.jobNumber };
    if (quoteFields.jobNumber && quoteFields.jobNumber !== "") {
      dispatch(showSpinner());
      dispatch(getPrcList(payload)).then((result) => {
        if (result?.prcList?.length && result?.prcList !== null) {
          const filteredPrcArr = result?.prcList?.filter((item) => item.jobNbr === quoteFields.jobNumber);
          function prcData(data) {
            const { prcNbr, descr } = data;
            return { prcNbr, descr };
          }
          setPrcOptions(filteredPrcArr.map(prcData));
        } else {
          setPrcOptions([]);
        }
        dispatch(hideSpinner());
      });
    }
    if (quoteFields.accountNumber === "" || !quoteFields.accountNumber) {
      dispatch(clearPrcList());
    }
  };

  const handleCancel = () => {
    setShowEditQuoteModal(false);
  };

  const handleChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    setState({ ...state, [key]: value });
    if (key === "quoteName") {
      setQuoteNameMaxLengthMsg(value.length >= 40 ? "Maximum of 40 characters has been reached" : "");
    }
  };

  const checkQuoteValidation = (date) => {
    const currentDate = new Date();
    const inputDate = new Date(date);
    let valid = true;
    setDateValid("");
    if (!date || date == "") {
      valid = false;
      setDateValid("Please enter a date");
    } else if (date && inputDate < currentDate) {
      valid = false;
      setDateValid("Cannot enter a past date");
    }
    return valid;
  };

  const handleDateType = (e) => {
    const value = e.target.value;
    if (value === "default") {
      setDateType("default");
      setState({ ...state, expirationDate: "Upon 30 days notice" });
    } else if (value === "manual") {
      setDateType("manual");
      setState({ ...state, expirationDate: "" });
    }
  };

  const handleSave = () => {
    var editPayload = {
      userName: sub,
      quoteId,
      quoteName: !state.quoteName ? "" : state.quoteName,
      territory: !quoteFields.territory ? "" : quoteFields.territory,
      expirationDate: !state.expirationDate ? "" : state.expirationDate,
      salesRep: !quoteFields.salesRep ? "" : quoteFields.salesRep,
      accountNumber: !quoteFields.accountNumber ? "" : quoteFields.accountNumber,
      accountName: !quoteFields.accountName ? "" : quoteFields.accountName,
      contactName: !quoteFields.contactName ? "" : quoteFields.contactName,
      phoneNumber: !quoteFields.phoneNumber ? "" : quoteFields.phoneNumber,
      customerName: !quoteFields.customerName ? "" : quoteFields.customerName,
      storeNumber: !quoteFields.storeNumber ? "" : quoteFields.storeNumber,
      storeName: !quoteFields.storeName ? "" : quoteFields.storeName,
      storePhoneNumber: !quoteFields.storePhoneNumber ? "" : quoteFields.storePhoneNumber,
      parentNumber: !quoteFields.parentNumber ? "" : quoteFields.parentNumber,
      parentName: !quoteFields.parentName ? "" : quoteFields.parentName,
      execName: !quoteFields.execName ? "" : quoteFields.execName,
      execNumber: !quoteFields.execNumber ? "" : quoteFields.execNumber,
      taxRate: !state.taxRate ? "0.00" : state.taxRate,
      city: !quoteFields.city ? "" : quoteFields.city,
      street: !quoteFields.street ? "" : quoteFields.street,
      zip: !quoteFields.zip ? "" : quoteFields.zip,
      state: !quoteFields.state ? "" : quoteFields.state,
      jobNumber: !state.jobNumber || state.jobNumber === "None Available" ? "" : state.jobNumber,
      jobName: !state.jobName ? "" : state.jobName,
      prcNumber: !state.prcNumber ? "" : state.prcNumber,
      prcDesc: !state.prcDesc || state.prcDesc === "None Available" ? "" : state.prcDesc,
      isTaxEdited: state.taxRate !== quoteFields.taxRate ? true : false,
      isPrcEdited: state.prcNumber !== quoteFields.prcNumber ? true : false,
      isStoreAccChanged: false,
    };

    if (showEditQuoteModal) {
      let quoteValid = false;
      quoteValid = checkQuoteValidation(state.expirationDate);
      if (quoteValid) {
        toast.promise(deprecatedEditQuote(editPayload).unwrap(), {
          success: "Quote details updated successfully",
          error: "Failed to update quote details",
          pending: "Updating quote details...",
        });
        setShowEditQuoteModal(false);
      } else {
        setShowEditQuoteModal(true);
      }
    }
  };

  const quoteEditModal = () => {
    return (
      <div>
        <form className="search-form-container__fields__form">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Quote Name"
                id="quoteName"
                maxLength={40}
                placeholder="Enter a quote name"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={state.quoteName || ""}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
                helpMsg={quoteNameMaxLengthMsg}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
              <InputField
                type="text"
                label="Tax Percentage"
                placeholder="Enter a number"
                id="taxRate"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={state.taxRate || ""}
                onChange={handleChange}
                disabled={false}
                isRequired={false}
              />
            </div>
          </div>

          <div className="col-12 form-group account-info__container">
            <p className="account-info__instruction px-0">Select an option for Date</p>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group">
              <input
                type="radio"
                name="type"
                value="default"
                onChange={handleDateType}
                className="radioBtn"
                checked={dateType === "default"}
              />
              Default Date
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group">
              <input
                type="radio"
                name="type"
                value="manual"
                onChange={handleDateType}
                className="radioBtn"
                checked={dateType === "manual"}
              />
              Select a Date
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
              {dateType === "default" ? (
                <InputField
                  type="text"
                  label="Expiration Date"
                  id="expirationDate"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.expirationDate || ""}
                  disabled={true}
                />
              ) : (
                <InputField
                  type="date"
                  label="Expiration Date"
                  id="expirationDate"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.expirationDate || ""}
                  onChange={(e) => setState({ ...state, expirationDate: e.target.value })}
                  errorMsg={dateValid}
                />
              )}
            </div>
          </div>
        </form>

        <div className="customer-details__title">
          <span className="customer-details__title--text">Pricing Information</span>
        </div>
        <form className="search-form-container__fields__form">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              {" "}
              <SelectInput
                inputRef={jobTypeNode}
                isJob={true}
                options={jobList}
                label="Job"
                isNA={jobList.length ? false : true}
                defaultValue={jobList?.length ? "Select a Job" : "None Available"}
                value={
                  state.jobNumber
                    ? state.jobName === ""
                      ? state.jobNumber
                      : state.jobNumber + " : " + state.jobName
                    : "None Available"
                }
                handleSelectInput={(e, value) => handleJob(e, value)}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              {" "}
              <SelectInput
                inputRef={customerTypeNode}
                isPrc={true}
                options={prcOptions}
                label="PRC"
                disabled={!state?.jobNumber}
                isNA={prcList?.length ? false : true}
                defaultValue={prcList?.length ? "Select a PRC" : "None Available"}
                value={
                  prcList?.length
                    ? state.prcNumber === ""
                      ? state.prcDesc
                      : state.prcNumber + " : " + state.prcDesc
                    : "None Available"
                }
                handleSelectInput={(e, value) => handlePRC(e, value)}
              />
            </div>
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="customer-details">
      <div className="d-flex customer-details__title justify-content-between mb-0">
        <div className="d-flex">
          <span className="customer-details__title--text">Quote Information</span>
        </div>
        {territoryAccess && (
          <div className="d-flex">
            <img src={edit} alt="quote" />
            &nbsp;
            <span className="customer-details__title--edit-text cursor-style" onClick={handleEditQuoteInfo}>
              Edit
            </span>
          </div>
        )}
      </div>

      <div className="d-md-flex flex-column flex-md-row mt-3 mt-md-5 overflow-auto position-relative" ref={detailsRef}>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Quote Name</div>
          <div className="info-item__value text-end text-md-start">{quoteFields.quoteName}</div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Quote ID</div>
          <div className="info-item__value text-end text-md-start">{quoteId}</div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Tax Percentage</div>
          <div className="info-item__value text-end text-md-start">{taxFormat(quoteFields.taxRate)}</div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Expiration Date</div>
          <div className="info-item__value text-end text-md-start">
            {["Upon 30 days notice", undefined, null].includes(quoteFields?.expirationDate)
              ? (quoteFields?.expirationDate ?? "")
              : formatDate(quoteFields?.expirationDate)}
          </div>
        </div>
      </div>

      <div className="customer-details__title mt-5">
        <span className="customer-details__title--text">Pricing Information</span>
      </div>

      <div className="d-md-flex flex-column flex-md-row mt-3 mt-md-5 overflow-auto position-relative" ref={detailsRef}>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">Job</div>
          <div className="info-item__value text-end text-md-start">
            {!quoteFields.jobNumber ? "N/A" : quoteFields.jobNumber + " : " + quoteFields.jobName}
          </div>
        </div>
        <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
          <div className="info-item__label">PRC</div>
          <div className="info-item__value text-end text-md-start">
            {!quoteFields.prcNumber ? "N/A" : quoteFields.prcNumber + " : " + quoteFields.prcDesc}
          </div>
        </div>
      </div>

      <div className="d-flex footer_display justify-content-between flex-column flex-md-row">
        <Button variant="outline-primary" onClick={() => navigate(`/priceQuote/${quoteId}#customer-details`)}>
          Back
        </Button>
        <Button className="m-0" variant="primary" onClick={() => navigate(`/priceQuote/${quoteId}#quote-summary`)}>
          View Summary
        </Button>
      </div>

      {showEditQuoteModal && (
        <Modal
          title={"Edit Quote Details"}
          saveButtonText={"Save"}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          size="lg"
        >
          {quoteEditModal()}
        </Modal>
      )}
    </div>
  );
};

export default QuoteDetails;
